interface KnownProvenance {
  englishName: string;
  germanName?: string;
}

export const allKnownProvenances: KnownProvenance[] = [
  {englishName: 'Unknown', germanName: 'Unbekannt'},
  {englishName: 'Alaca'},
  {englishName: 'Alalaḫ'},
  {englishName: 'Alişar'},
  {englishName: 'Amarna'},
  {englishName: 'Boğazköy'},
  {englishName: 'Boğazköy Büyükkale'},
  {englishName: 'Boğazköy Büyükkale A'},
  {englishName: 'Boğazköy Büyükkale B'},
  {englishName: 'Boğazköy Büyükkale C'},
  {englishName: 'Boğazköy Büyükkale D'},
  {englishName: 'Boğazköy Büyükkale E'},
  {englishName: 'Boğazköy Büyükkale F'},
  {englishName: 'Boğazköy Büyükkale G'},
  {englishName: 'Boğazköy Büyükkale H'},
  {englishName: 'Boğazköy Büyükkale J'},
  {englishName: 'Boğazköy Büyükkale K'},
  {englishName: 'Boğazköy Büyükkale L'},
  {englishName: 'Boğazköy Büyükkale M'},
  {englishName: 'Boğazköy Büyükkale N'},
  {englishName: 'Boğazköy Büyükkaya'},
  {englishName: 'Boğazköy House on the Slope', germanName: 'Boğazköy Haus am Hang'},
  {englishName: 'Boğazköy Lower City', germanName: 'Boğazköy Oberstadt'},
  {englishName: 'Boğazköy Temple I', germanName: 'Boğazköy Tempel I'},
  {englishName: 'Boğazköy Temple II', germanName: 'Boğazköy Tempel II'},
  {englishName: 'Boğazköy Temple III', germanName: 'Boğazköy Tempel III'},
  {englishName: 'Boğazköy Temple IV', germanName: 'Boğazköy Tempel IV'},
  {englishName: 'Boğazköy Temple V', germanName: 'Boğazköy Tempel V'},
  {englishName: 'Boğazköy Temple VI', germanName: 'Boğazköy Tempel VI'},
  {englishName: 'Boğazköy Temple VII', germanName: 'Boğazköy Tempel VII'},
  {englishName: 'Boğazköy Temple VIII', germanName: 'Boğazköy Tempel VIII'},
  {englishName: 'Boğazköy Temple IX', germanName: 'Boğazköy Tempel IX'},
  {englishName: 'Boğazköy Temple X', germanName: 'Boğazköy Tempel X'},
  {englishName: 'Boğazköy Temple XI', germanName: 'Boğazköy Tempel XI'},
  {englishName: 'Boğazköy Temple XII', germanName: 'Boğazköy Tempel XII'},
  {englishName: 'Boğazköy Temple XV', germanName: 'Boğazköy Tempel XV'},
  {englishName: 'Boğazköy Temple XVI', germanName: 'Boğazköy Tempel XVI'},
  {englishName: 'Boğazköy Temple XVIII', germanName: 'Boğazköy Tempel XVIII'},
  {englishName: 'Boğazköy Temple XIX', germanName: 'Boğazköy Tempel XIX'},
  {englishName: 'Boğazköy Temple XX', germanName: 'Boğazköy Tempel XX'},
  {englishName: 'Boğazköy Temple XXVI', germanName: 'Boğazköy Tempel XXVI'},
  {englishName: 'Boğazköy Temple XXX', germanName: 'Boğazköy Tempel XXX'},
  {englishName: 'Boğazköy Upper City', germanName: 'Boğazköy Unterstadt'},
  {englishName: 'Büklükale'},
  {englishName: 'Emar'},
  {englishName: 'Eskiyapar'},
  {englishName: 'İnandık'},
  {englishName: 'Karkamiš'},
  {englishName: 'Kayalıpınar'},
  {englishName: 'Kuşaklı A'},
  {englishName: 'Kuşaklı C'},
  {englishName: 'Kuşaklı Hilltop'},
  {englishName: 'Kuşsaray'},
  {englishName: 'Maşat Höyük'},
  {englishName: 'Ortaköy'},
  {englishName: 'Oylum Höyük'},
  {englishName: 'Oymaağaç'},
  {englishName: 'Tarsus'},
  {englishName: 'Tell Afis'},
  {englishName: 'Ugarit'},
  {englishName: 'Uşaklı/Kuşaklı'},
  {englishName: 'Yassıhüyük'}
];

